<template>
  <div class="package">
    <div class="panel-header">
      <h3 class="panel-header__title">渠道包管理</h3>
      <span class="panel-header__subtitle">PACKAGE MANAGEMENT</span>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">渠道包管理</h3>
      <up-form class="panel-content__form" :model="form" :rules="rules" ref="form" label-width="130px" v-loading="loading" element-loading-text="加载中...">
        <up-form-item-select v-if="platform === 'agency'" label="所属广告主：" prop="advertiser_id" v-model="form.advertiser_id" :disabled="disabledField" :data="adUsers" placeholder="请选择所属广告主"></up-form-item-select>
        <up-form-item label="上传APK：" prop="apk_path">
          <up-upload action="whatever" :show-file-list="false" :before-upload="beforeApkUpload" :http-request="handleApkChange" :disabled="type === 'view'">
            <up-button type="primary">上传APK</up-button>
            <div slot="tip" class="package__upload-tip">不超过1G，文件格式：APK</div>
          </up-upload>
          <up-progress v-if="uploading" style="margin-left: 16px; width: 250px;" :percentage="currentPercentage"></up-progress>
          <div v-if="type === 'view' && form.apk_path" style="margin-left: 16px;">{{form.apk_path}}</div>
        </up-form-item>
        <up-form-item label="ICON：" prop="icon">
          <up-upload class="package__icon-upload" action="whatever" :show-file-list="false" :http-request="handleIconChange" :disabled="type === 'view'">
            <img v-if="form.icon" :src="form.icon" class="package__icon-upload--picture" alt="ICON" />
            <i v-else class="el-icon-plus package__icon-upload--icon"></i>
            <div slot="tip" class="package__upload-tip">需要上传完整正方形图片，尺寸：512*512，大小500k以内，图片格式：png</div>
          </up-upload>
        </up-form-item>
        <up-form-item-input class="w364" label="名称：" prop="name" v-model="form.name" placeholder="请输入名称"></up-form-item-input>
        <up-form-item-input disabled class="w364" label="包名：" prop="app_name" v-model="form.app_name" placeholder="请输入包称"></up-form-item-input>
        <up-form-item-input disabled class="w364" label="版本号：" prop="version_num" v-model="form.version_num" placeholder="请输入版本号"></up-form-item-input>
        <up-form-item-input disabled class="w364" label="版本名称：" prop="version_name" v-model="form.version_name" placeholder="请输入版本名称"></up-form-item-input>
        <up-form-item-select label="行业" prop="industry" v-model="form.industry" :data="industries"></up-form-item-select>
        <up-form-item-input class="w364" type="textarea" label="备注" prop="remark" v-model="form.remark" :rows="6"></up-form-item-input>
        <div class="panel-content__btn-group">
          <template v-if="type !== 'view'">
            <div class="panel-content__btn"><up-button size="large" type="primary" @click="submitForm('form')">{{ btnText('保存') }}</up-button></div>
          </template>
          <div class="panel-content__btn"><up-button size="large" class="is-cancel" @click="$router.go(-1)">取消</up-button></div>
        </div>
      </up-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { loadImage } from '@/global/util/util'

export default {
  name: 'package-add',
  data () {
    return {
      adUsers: [],
      platform: '',
      id: '',
      type: '',
      currentPercentage: 0,
      uploading: false,
      form: {
        advertiser_id: '',
        apk_path: '',
        apk_size: '',
        md5_apk_file: '',
        icon: '',
        name: '',
        app_name: '',
        version_num: '',
        version_name: '',
        industry: '',
        remark: ''
      },
      rules: {
        apk_path: [{ required: true, message: '请上传APK包', trigger: 'change' }],
        icon: [{ required: true, message: '请上传ICON', trigger: 'change' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        app_name: [{ required: true, message: '请输入包名', trigger: 'blur' }],
        version_num: [{ required: true, message: '请输入版本号', trigger: 'blur' }],
        version_name: [{ required: true, message: '请输入版本名称', trigger: 'blur' }],
        industry: [{ required: true, message: '请选择行业', trigger: 'change' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      industries: [],
      submitted: false,
      submitting: false,
      verifying: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'login/user'
    }),
    btnText () {
      return function (text) {
        return this.submitting ? `${text}中...` : this.submitted ? `已${text}` : text
      }
    },
    disabledField () {
      return ['edit', 'view'].includes(this.type)
    }
  },
  methods: {
    ...mapActions([
      'channel/getAdUsers',
      'channel/validateOrderName',
      'channel/addAndUpdateChannel',
      'channel/getChannelDetail',
      'channel/uploadApk',
      'channel/uploadIcon',
      'etcd/getItem'
    ]),
    async getAdUsers () {
      const [err, res] = await this['channel/getAdUsers']()
      if (err || res.code !== 1) this.$message.error('获取广告主列表失败')
      else {
        this.adUsers = res.code === 1 ? res.data : []
      }
    },
    beforeApkUpload (file) {
      const isLt1GB = file.size / 1024 / 1024 / 1024 < 1
      const isLt10MB = file.size / 1024 / 1024 < 10
      const isApk = file.type === 'application/vnd.android.package-archive'
      if (VUE_APP_ENV === 'online') {
        if (!isLt1GB) {
          this.$message.error('APK大小不能超过 1GB!')
        }
      } else {
        if (!isLt10MB) {
          this.$message.error('APK大小不能超过 10MB!')
        }
      }

      if (!isApk) {
        this.$message.error('APK文件格式不正确!')
      }
      return isApk
    },
    async handleApkChange ({ file, onProgress }) {
      const formData = new FormData()
      formData.append('file', file)
      this.uploading = true
      this.currentPercentage = 0
      const [err, res] = await this['channel/uploadApk']({
        formData,
        config: {
          onUploadProgress: ({ loaded, total }) => {
            this.currentPercentage = Math.round((loaded / total).toFixed(2) * 100)
          }
        }
      })
      if (err || res.code !== 1) {
        this.uploading = false
        this.currentPercentage = 0
        return this.$message.error(res.msg || '上传APK失败')
      }
      const { path, ...rest } = res.data
      this.form = Object.assign(this.form, {
        ...rest,
        apk_path: path
      })
      this.$refs.form.validateField(['apk_path', 'app_name', 'version_num', 'version_name'])
      this.$message.success('上传APK成功')
    },
    async beforeIconUpload (file) {
      const image = await loadImage(file)
      const isLt500KB = file.size / 1024 < 500
      const isMatch = image.width === 512 && image.height === 512

      if (!isMatch) {
        this.$message.error(`图标尺寸必须是 512*512，而你上传的是${image.width}*${image.height}!`)
      }

      if (!isLt500KB) {
        this.$message.error('图标大小不能超过 500KB!')
      }

      return isLt500KB && isMatch
    },
    async handleIconChange ({ file }) {
      const isValid = await this.beforeIconUpload(file)
      if (!isValid) return

      const formData = new FormData()
      formData.append('file', file)
      const [err, res] = await this['channel/uploadIcon'](formData)
      if (err) { return this.$message.error('上传ICON失败') }
      this.form.icon = res.data.path
      this.$refs.form.validateField('icon')
      this.$message.success('上传ICON成功')
    },
    submitForm (formName, next) {
      if (this.verifying) return
      this.verifying = true
      if (this.submitted || this.submitting) return this.$message.error('请勿重复提交数据！')
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitting = true
          this.verifying = false

          const text = this.type === 'edit' ? '修改' : '添加'
          // 广告主平台移除
          const formData = this.form
          if (this.platform !== 'agency') {
            formData.advertiser_id = this.user.equal_to_account
          }

          const [err, res] = await this['channel/addAndUpdateChannel']({ type: this.type, id: this.id, params: formData })
          this.submitting = false
          if (err) return this.$message.error(`${text}渠道包失败`)
          else if (res.code !== 1) {
            return this.$message.error(res.msg)
          } else {
            this.submitted = true
            this.$message.success(`${text}渠道包成功`)
            setTimeout(_ => this.$router.push({ path: '/channels' }), 2000)
          }
        } else {
          this.$message.error('请填写完整信息！')
          this.verifying = false
          return false
        }
      })
    }
  },
  async created () {
    const { type, id = '' } = this.$route.params
    this.platform = this.$route.meta.platform
    this.type = type
    this.id = id
    this.loading = true
    if (this.platform === 'agency') this.getAdUsers()

    // 获取行业列表
    this['etcd/getItem']('apps-category')
      .then(res => {
        this.industries = res.data
      })

    if (this.id) {
      const [err, res] = await this['channel/getChannelDetail']({ platform: this.platform, id: this.id })
      if (err) this.$message.error('获取渠道包信息失败！')
      else {
        const { advertiser_id: advertiserId, icon, apk_path: apkPath, apk_size: apkSize, md5_apk_file: md5ApkFile, name, app_name: appName, version_name: versionName, version_num: versionNum, industry, remark } = res.data
        this.form = Object.assign({}, this.form, {
          advertiser_id: advertiserId,
          apk_path: apkPath,
          apk_size: apkSize,
          md5_apk_file: md5ApkFile,
          icon,
          name,
          app_name: appName,
          version_num: versionNum,
          version_name: versionName,
          industry,
          remark
        })
      }
    }
    this.loading = false
  }
}
</script>

<style lang="scss">
  @include b(package) {
    @include e(icon-upload) {
      $--icon-width: 82px;

      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409EFF;
        }
      }

      @include m(picture) {
        width: $--icon-width;
        height: $--icon-width;
        display: block;
      }

      @include m(icon) {
        font-size: 28px;
        color: #8c939d;
        width: $--icon-width;
        height: $--icon-width;
        line-height: $--icon-width;
        text-align: center;
      }
    }

    @include e(upload-tip) {
      margin-left: 16px;
      font-size: 12px;
    }
  }
</style>
